export default "__VITE_ASSET__OKRh9bqU__"